<div class="message-simple-wrapper player-common-component">

  <div class="space-wrapper"></div>

  <div class="content" *ngIf="messageSimple">
    <div class="title">
        {{messageSimple.title ? messageSimple.title : "メッセージタイトル"}}
    </div>
    <div class="description" *ngIf="messageSimple.description">
      <span #descriptionElement [innerHTML]="messageSimple.description | linky:{stripPrefix:false}"></span>
    </div>

  </div>

  <div class="controls-wrapper">
    <div class="back-forward">

      <div class="forward btn show"></div>

      <div class="center btn show" *ngIf="messageSimple.trigger" (click)="forwardClicked()">
        次へ<mat-icon class="material-icons-rounded">arrow_forward_ios</mat-icon>
      </div>

      <div class="center btn show" *ngIf="! messageSimple.trigger" (click)="forwardClicked()">
        <mat-icon class="material-icons-rounded">close</mat-icon>閉じる
      </div>

      <div class="forward btn show"></div>

    </div>
  </div>

</div>
